// START IMPORTS
// Context imports
import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
// Core lib v1 imports
import { MonitoringOverview, useSriracha } from '@ltvco/refresh-lib/v1';
// Core lib v2 imports
import {
  FeatureBlockedModal,
  useFeatureBlockedModal,
} from '@ltvco/refresh-lib/v2';
// Vendor imports
import { useState } from 'react';

// App-specific imports
import { constants } from 'appConstants';
// END IMPORTS

export function Monitoring() {
  // START HOOKS_AND_QUERIES
  const { data } = useSriracha();
  const {
    isFeatureBlockedModalOpen,
    closeFeatureBlockedModal,
    openFeatureBlockedModal,
  } = useFeatureBlockedModal();
  const { isBlocked } = useSubscriptionAccessConfigContext();
  // END HOOKS_AND_QUERIES

  // START STATE_MANAGEMENT
  const [searchType, setSearchType] = useState('');
  const [paymentShowModalNumber, setPaymentShowModalNumber] =
    useState<number>(0);
  // END STATE_MANAGEMENT

  // START DERIVED_DATA_AND_UTILS
  const notifications = data || [];

  const checkIfPeopleSearchIsBlocked = () => {
    const { peopleSubSearches } = constants.data;
    return peopleSubSearches.some((searchType) => isBlocked(searchType));
  };

  const peopleSearchBlocked = checkIfPeopleSearchIsBlocked();
  // END DERIVED_DATA_AND_UTILS

  // START EVENT_HANDLERS
  const onClickHandler = () => {
    if (peopleSearchBlocked) {
      setSearchType('People');
      openFeatureBlockedModal();
    }
  };
  // END EVENT_HANDLERS

  // START RENDER
  return (
    <>
      <MonitoringOverview
        notifications={notifications}
        onClickHandler={onClickHandler}
        searchBlocked={peopleSearchBlocked}
      />
      <FeatureBlockedModal
        isOpen={isFeatureBlockedModalOpen}
        onClose={closeFeatureBlockedModal}
        searchType={searchType}
        paymentShowModalNumber={paymentShowModalNumber}
        setPaymentShowModalNumber={setPaymentShowModalNumber}
      />
    </>
  );
  // END RENDER
}
